import React, { forwardRef } from "react";

const sizes = {
  small: "w-8 h-8",
  medium: "w-10 h-10",
};

const IconButton = forwardRef((props, ref) => {
  const {
    children,
    className = "",
    disabled = false,
    size = "medium",
    color,
    edge,
    type = "button",
    ...buttonProps
  } = props;

  const edgeClass =
    edge === "start" ? "-ml-2" : edge === "end" ? "-mr-2" : "";
  const colorClass =
    color === "primary"
      ? "text-[var(--primaryColor)]"
      : color === "secondary"
      ? "text-farmazon-text-muted"
      : color === "inherit"
      ? "text-inherit"
      : "text-farmazon-text";

  return (
    <button
      {...buttonProps}
      ref={ref}
      type={type}
      disabled={disabled}
      className={`inline-flex flex-shrink-0 cursor-pointer appearance-none items-center justify-center rounded-full border-0 bg-transparent outline-none transition-colors hover:bg-farmazon-hover focus:ring-2 focus:ring-slate-500/20 disabled:cursor-not-allowed disabled:opacity-40 ${sizes[size] || sizes.medium} ${colorClass} ${edgeClass} ${className}`}
    >
      {children}
    </button>
  );
});

IconButton.displayName = "IconButton";

export default IconButton;
